import"./Plane.css"
export default function Plane(){
    return(
        <div>
            <section class="schedule">
            <h2>برنامه کلاس‌های شنا در تبریز</h2>
            <div class="schedule-box">
                <div>🗓 روزهای کاری: همه‌روزه</div>
                <div>📍 محل برگزاری: استخر کوثر تبریز</div>
                <div>👥 ظرفیت کلاس نیمه‌خصوصی: 3 نفر</div>
                <div>👥 ظرفیت کلاس عمومی: 5 نفر</div>
            </div>
            </section>
        </div>
    )
}